import { Button, ButtonVariants } from '@components/button/Button';
import { PageContent } from 'restaurantAdmin/layout/PageContent';
import { PageHeader } from 'restaurantAdmin/layout/PageHeader';
import { ForecastCalendar } from './ForecastCalendar';
import { PricingPageNavLinks } from './PricingPageNavLinks';

export const ForecastPage = () => {
  return (
    <>
      <PageHeader title="Pricing" category="Operations">
        {/* Forecast is read-only for now — no edits to save yet, so the nav
            links and Save button are inert until editing lands. */}
        <PricingPageNavLinks
          userHasUnsavedChanges={false}
          saveChanges={() => {}}
          modalMessage={null}
        />
        <Button
          label="Save and Apply"
          onClick={() => {}}
          variant={ButtonVariants.Primary}
          isDisabled
        />
      </PageHeader>
      <PageContent>
        <ForecastCalendar />
      </PageContent>
    </>
  );
};
